import { AnvandareDTO } from "~app/common/models/anvandare/AnvandareDTO";
import { Arbetsordertyper, Produktionsstatus } from "~app/common/models/constants";
import { ArbetsorderTidpunktDTO } from "~app/common/models/planera/ArbetsorderTidpunktDTO";
import { VillkorligtDatumDTO } from "~app/common/models/planera/VillkorligtDatumDTO";
import { TullkontorDTO } from "~app/common/models/tullkontor/TullkontorDto";
import { CommandManager, ICommandManager } from "~app/common/services/cqs/commandManager";
import { IKartgeometri } from "~app/features/map/popups/kartgeometri-popup/kartgeometri.model";
import { AttachAtgardToArbetsorderCommand } from "~app/features/planera/commands/AttachAtgardToArbetsorderCommand";
import { MoveAtgarderToNewArbetsorderCommand } from "~app/features/planera/commands/MoveAtgarderToNewArbetsorderCommand";
import { UpdateArbetsorderProduktsattCommand } from "~app/features/planera/commands/UpdateArbetsorderProduktsattCommand";
import { Arbetsorder } from "./Arbetsorder";
import { ArbetsorderDisabledFlag } from "./ArbetsorderDisabledFlag";

import { IArbetsorderDetail } from "./IArbetsorderDetail";
import { IArbetsorderHandelssortiment } from "./IArbetsorderHandelssortiment";
import { IArbetsorderRestriktion } from "./IArbetsorderRestriktion";
import { IAtgard } from "./IAtgard";
import { IExtent } from "./IExtent";
import { IOperation } from "./IOperation";
import { IUtbytesberakning } from "./IUtbytesberakning";
import { IVirkeskopskontraktDetail } from "./IVirkeskopskontraktDetail";

export class ArbetsorderDetail extends Arbetsorder implements IArbetsorderDetail {
    hektar: number;
    atgarder: IAtgard[];
    easting: number;
    northing: number;
    extent: IExtent;
    utbytesberakningar: IUtbytesberakning[];
    handelssortiment: IArbetsorderHandelssortiment[];
    restriktioner: IArbetsorderRestriktion[];
    villkorligaDatum: VillkorligtDatumDTO[];
    tidpunkter: ArbetsorderTidpunktDTO;
    kartgeometrier: IKartgeometri[];
    maskinlagId: number;
    operationer: IOperation[];
    arbetsorderStartdatum: string;
    arbetsorderSlutdatum: string;
    produktionsomradeId: number;
    resultatomradeId: number;
    rowVersion: string;
    guid: string;
    gyl: string;
    kontraktsanteckningAvverkningsdirektiv: string;
    kontraktsanteckningTransportorder: string;
    lkd: string;
    virkeskopskontraktDetail: IVirkeskopskontraktDetail;
    anteckningProduktionsplanering: string;
    frislappningsdatum?: string;
    commandManager: ICommandManager;
    arbetsorderValsSynkroniseringstatus: string;
    ansvarigAvverkningsledare: AnvandareDTO;
    anteckningVirkesorder?: string;
    uppdragId?: number;
    produktionGodkandAv?: string;
    virketMarkt?: string;
    vardekap: boolean;
    selected?: boolean;
    voContractDirty: boolean;
    aktuellVirkesorderStatus?: string;
    virkesorderSenastMottagenOk?: Date;
    virkesirderSenastAckadGeneration?: number;
    skickadTillViol: boolean;
    internProduktionsstatus: number;
    transportforetagId: number;
    tullkontor: TullkontorDTO;
    isExport: boolean;
    produktionsstatus?: string;
    batId: string;
    hamtplats: string;
    ckLeverantor: string;
    fscCertifikat?: boolean;
    pefcCertifikat?: boolean;
    anvandVerkligaAvlagg: boolean;
    avgangsmatning?: boolean;
    hover?: boolean;
    filterData?: string;
    eudrValid: boolean;

    private isDestineringsalternativValid: boolean;
    private static readonly kontraktTypGrot = "Grot";

    constructor(arbetsorderDetail: IArbetsorderDetail) {
        super(arbetsorderDetail);

        this.commandManager = new CommandManager();

        this.commandManager.onCommandReceived(c => {
            if (
                (c.$type === MoveAtgarderToNewArbetsorderCommand.$type ||
                c.$type === AttachAtgardToArbetsorderCommand.$type) &&
                this.typ !== Arbetsordertyper.Grotskotning
            ) {
                this.setProduktsatt(false);
            }
        });
    }

    setProduktsatt(value: boolean): void {
        if (this.typ === Arbetsordertyper.Grotskotning) {
            return;
        }

        this.produktsatt = value;
        this.commandManager.updateCommand(
            new UpdateArbetsorderProduktsattCommand((c) => {
                c.arbetsorderId = this.id;
                c.produktsatt = value;
            })
        );
    }

    get isLeveransGrot(): boolean {
        return this.isLeveransvirke &&
            this.virkeskopskontraktDetail &&
            this.virkeskopskontraktDetail.kontraktTyp === ArbetsorderDetail.kontraktTypGrot;
    }

    get isCertifikatValidForAllHandelssortiment(): boolean {
        if (this.handelssortiment.length === 0) {
            return false;
        }
        return !(this.handelssortiment.some(x => x.ocertifierat === true) &&
        (this.fscCertifikat || this.pefcCertifikat));
    }

    /* eslint-disable no-bitwise */
    isEditableForMode(mode: ArbetsorderDisabledFlag) {
        let isEditable = true;

        if ((mode & ArbetsorderDisabledFlag.makulerad) !== 0) {
            isEditable = isEditable && this.produktionsstatus !== Produktionsstatus.Makulerad;
        }

        return isEditable;
    }

    get isDestineringsalternativValidForSave(): boolean {
        return this.isDestineringsalternativValid !== false;
    }

    set isDestineringsalternativValidForSave(value: boolean) {
        this.isDestineringsalternativValid = value;
    }
}
